import fire from '@store/firebase';
import { CollectionPath } from '@typings/collections.enum';

const firestore = fire.firestore();
const usersRef = firestore.collection(CollectionPath.USERS);
const auth = fire.auth();

export async function getMembers() {
  const userList = await usersRef.get().then((res) => res.docs);

  const userMap = userList.map((doc) => {
    return {
      id: doc.id,
      value: doc.data().displayName,
      photoURL: doc.data().photoURL,
    };
  });

  return userMap;
}

// 익명 유저 가져오기
export async function getAnonymousUser() {
  const uid = await auth.onAuthStateChanged((user) => {
    if (user) {
      const uid = user.uid;
      return uid;
    } else {
      // User is signed out
    }
  });

  return uid;
}
